import React, { Component } from 'react';
import Switch from "react-switch";
import './sidebar.css';
import '../../containers/compositions/compositions.css';
import {
  SidebarBtn,
  SidebarSubitem,
  HelpChat
} from '../';
import RDP_CONFIG from '../../config';
import { getTheme } from '../../utils/getTheme';
import ReactTooltip from 'react-tooltip';
import {UserService} from '../../services/user';
import {DamService} from '../../services/dam';
import replaceCompositionObjectsIds from "../../utils/replaceCompositionObjectsIds";
import {
  ElementHead1,
  ElementText,
  ElementTextTwoColumn,
  ElementList,
  ElementImage,
  ElementAudio,
  ElementVideo,
  ElementVideoInteractive1,
  ElementIframe,
  ElementAccordion,
  ElementTabs,
  ElementFlashcards1,
  ElementFlashcards2,
  ElementQuiz1,
  ElementQuiz2,
  ElementQuiz3,
  ElementQuiz4,
  ElementQuiz5,
  ElementQuiz6,
  ElementImagesGallery,
  ElementImageAndText,
  ElementImageWithText,
  ElementForum1,
  ElementDivider1,
  ElementDividerNumbered,
  VirtualElementIndex1,
  ElementHotspots1,
  ElementStatement1,
  ElementStatement2,
  ElementStatement3,
  ElementStatement4,
  ElementNote1,
  ElementQuote1,
  ElementQuote2,
  ElementQuote3,
  ElementQuote4,
  ElementQuote5,
  ElementQuote6,
  ElementSortedActivity1,
  ElementTimeline1,
  ElementSteps1,
  ElementAttachment1,
  ElementGallery1,
  ElementCodeSnippet1,
  ElementButton1,
  ElementDivider4,
  Element3d,
  ElementMathFormula
} from '../../elements';

export default class Sidebar extends Component {
  categorizeTemplates() {
    var categories = {
      'Cabeçalhos': [],
      'Textos': [],
      'Listas': [],
      'Imagens': [],
      'Galerias': [],
      'Multimídias': [],
      'Interatividades': [],
      'Quizzes': [],
      'Atividades': [],
      'Planejamento': [],
      'Marcadores': []
    };

    var categoryMap = {
      'Cabeçalhos': ["rdpcomposer_template_element_head_1"],
      'Textos': [
        "rdpcomposer_template_element_text_1",
        "rdpcomposer_template_element_text_2", 
        "rdpcomposer_template_element_text_3",
        "rdpcomposer_template_element_text_4",
        "rdpcomposer_template_element_text_5",
        "rdpcomposer_template_element_text_6",
        "rdpcomposer_template_element_text_two_column",
        "rdpcomposer_template_element_statement_1",
        "rdpcomposer_template_element_statement_2",
        "rdpcomposer_template_element_statement_3",
        "rdpcomposer_template_element_statement_4",
        "rdpcomposer_template_element_note_1",
        "rdpcomposer_template_element_quote_1",
        "rdpcomposer_template_element_quote_2",
        "rdpcomposer_template_element_quote_3",
        "rdpcomposer_template_element_quote_4",
        "rdpcomposer_template_element_quote_5",
        "rdpcomposer_template_element_quote_6"
      ],
      'Listas': [
        "rdpcomposer_template_element_list_1",
        "rdpcomposer_template_element_list_2",
        "rdpcomposer_template_element_list_3"
      ],
      'Imagens': [
        "rdpcomposer_template_element_image_1",
        "rdpcomposer_template_element_image_2",
        "rdpcomposer_template_element_image_and_text",
        "rdpcomposer_template_element_image_with_text"
      ],
      'Galerias': ["rdpcomposer_template_element_gallery_1"],
      'Multimídias': [
        "rdpcomposer_template_element_video_1",
        "rdpcomposer_template_element_audio_1",
        "rdpcomposer_template_element_iframe"
      ],
      'Interatividades': [
        "rdpcomposer_template_element_accordion",
        "rdpcomposer_template_element_tabs",
        "rdpcomposer_template_element_flashcards_1",
        "rdpcomposer_template_element_flashcards_2",
        "rdpcomposer_template_element_hotspots_1",
        "rdpcomposer_template_element_timeline_1",
        "rdpcomposer_template_element_steps_1",
        "rdpcomposer_template_element_attachment_1",
        "rdpcomposer_template_element_snippet_1",
        "rdpcomposer_template_element_3d",
        "rdpcomposer_template_element_math_formula"
      ],
      'Quizzes': [
        "rdpcomposer_template_element_quiz_1",
        "rdpcomposer_template_element_quiz_2",
        "rdpcomposer_template_element_quiz_3",
        "rdpcomposer_template_element_quiz_5"
      ],
      'Atividades': ["rdpcomposer_template_element_forum_1"],
      'Planejamento': ["rdpcomposer_template_element_matriz_didatica"],
      'Marcadores': [
        "rdpcomposer_template_element_divider_1",
        "rdpcomposer_template_element_divider_4",
        "rdpcomposer_template_element_divider_numbered"
      ]
    };

    this.state.templates.forEach(template => {
      var type = template.document.content_type.replace('application/', '');
      var categorized = false;
      
      for (var categoryName in categoryMap) {
        if (categoryMap[categoryName].includes(type)) {
          categories[categoryName].push(template);
          categorized = true;
          break;
        }
      }
      
      if (!categorized) {
        console.log('Uncategorized type:', type);
        categories['Marcadores'].push(template);
      }
    });

    return categories;
  }

  normalizeText(text) {
    return text.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  handleSearchChange(event) {
    this.setState({ searchTerm: event.target.value });
  }

  getFilteredTemplates() {
    if (!this.state.searchTerm.trim()) {
      return null; // Return null to show categories
    }

    var searchTerm = this.normalizeText(this.state.searchTerm);
    return this.state.templates.filter(template => {
      var fileName = template.metadata ? template.metadata.file_name : '';
      return this.normalizeText(fileName).includes(searchTerm);
    });
  }

  toggleCategory(categoryName) {
    var expandedCategories = {...this.state.expandedCategories};
    expandedCategories[categoryName] = !expandedCategories[categoryName];
    this.setState({ expandedCategories });
  }

  constructor(props) {
    super(props);

    this.state = {
      "subitems": "none",
      "theme": getTheme(),
      "imageListWithErrors": [],
      "previousError": false,
      "render_templates": false,
      "templates": [],
      "templatesContent": {},
      "expandedCategories": {},
      "searchTerm": ""
    };

    this.renderSubitems = this.renderSubitems.bind(this);
    this.closeSubitems = this.closeSubitems.bind(this);
    this.onClickSubitem = this.onClickSubitem.bind(this);
    this.openPreview = this.openPreview.bind(this);
    this.handleEsc = this.handleEsc.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleEsc);
    this.getTemplates();
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleEsc);
  }

  handleEsc(event) {
    if (event.key === "Escape") {
      this.setState({
        "subitems": "none",
        "render_templates": false
      })
    }
  }

  checkCompositionImagesWithError() {
    const brokens = document.querySelectorAll('.broken-img');
    const absoluteBrokens = document.querySelectorAll('.broken-img-absolute');
    const imagesWithFailure = [
      ...Array.from(brokens),
      ...Array.from(absoluteBrokens)
    ];
    
    if (imagesWithFailure.length !== this.state.imageListWithErrors.length) {
      this.setState({ imageListWithErrors: imagesWithFailure });
    }
  };

  handleClickShowImagesWithError() {
    const [element] = this.state.imageListWithErrors;

    element.scrollIntoView();
  };

  componentDidUpdate() {
    this.checkCompositionImagesWithError();

    if (!this.state.previousError && this.state.imageListWithErrors.length) {
      this.setState({ previousError: true })
    }
  }

  renderSubitems(type) {
    this.setState({
      subitems: type
    });
  }

  closeSubitems() {
    this.setState({
      subitems: "none"
    })
  }

  onClickSubitem(type) {
    this.closeSubitems();
    this.props.onClickSubitem(type);
  }

  openPreview() {
    window.location.href = window.location.href + "/preview";
  }


  renderMenu() {
    const {
      openedMenu,
      isUserCreatorColaborator,
      isUserCreatorViewer
    } = this.props;

    if (openedMenu === true) {
      return <div className="rdp-composer-sidebar-menu-container">
        <div className="rdp-composer-sidebar-menu-container-overlay" onClick={() => this.props.onToggleMenu()}></div>
        <ul className="rdp-composer-sidebar-menu-container-popup">
          {!isUserCreatorViewer &&
            <li className="rdp-composer-sidebar-menu-container-popup-item save" onClick={() => this.props.onSaveClick()}>{this.props.labels.header.menu_save_composition}</li>
          }
          {!isUserCreatorViewer &&
            <li className="rdp-composer-sidebar-menu-container-popup-item metadata" onClick={() => this.props.onConfigurationClick()}>{this.props.labels.header.menu_settings}</li>
          }
          {!isUserCreatorViewer &&
            <li className="rdp-composer-sidebar-menu-container-popup-item history" onClick={() => this.props.onVersionsHistoryClick()}>{this.props.labels.header.menu_versions_history}</li>
          }
          {!isUserCreatorViewer && !isUserCreatorColaborator && (typeof this.props.onZipExport === "function") &&
            <>
              {this.state.imageListWithErrors.length > 0 ? (
                <>
                  <ReactTooltip
                  id="export-zip-error"
                  className="rdp-tooltip"
                  multiline={true}
                  place="bottom"
                  type="dark"
                  backgroundColor="#1b1b1bda"
                  />
                  <li
                    data-for="export-zip-error"
                    data-tip={
                      `Sua composição está com arquivos indisponíveis. Clique aqui para verificar os objetos e realizar as alterações necessárias.`}
                    className="rdp-composer-sidebar-menu-container-popup-item zip-error"
                    onClick={() => this.handleClickShowImagesWithError()}
                    >
                    
                    {this.props.labels.header.menu_export_zip}
                  </li>
                </>  
              ) : (
                <li
                  className="rdp-composer-sidebar-menu-container-popup-item zip"
                  onClick={() => this.props.onZipExport(this.state.previousError)}
                >
                  {this.props.labels.header.menu_export_zip}
                </li>
              )}
            </>
          }
          <li className={`rdp-composer-sidebar-menu-container-popup-item preview ${this.props.previewEnabled === false ? "disabled" : ""}`} onClick={() => this.props.onPreviewClick()}>{this.props.labels.header.menu_preview}</li>
          
          {this.props.enabledWorkflows &&
            <>
              <li className="rdp-composer-sidebar-menu-container-popup-item template">
                {this.props.labels.header.menu_template}
                <div className="rdp-composer-sidebar-menu-container-popup-item-switch">
                  <Switch
                    checkedIcon={false}
                    uncheckedIcon={false}
                    onChange={(bool) => this.props.toggleIsTemplate(bool)}
                    checked={this.props.isTemplate}
                    width={38}
                    height={20}
                  />
                </div>
              </li>
              {this.props.isTemplate &&
                <li className={`rdp-composer-sidebar-menu-container-popup-item processes`} onClick={() => this.props.onProcessesClick()}>{this.props.labels.header.menu_processes}</li>
              }
            </>
          }
        </ul>
      </div>;
    };
  }

  getAllMimeTypes() {
    return [
      "rdpcomposer_template_element_text_1",
      "rdpcomposer_template_element_text_2",
      "rdpcomposer_template_element_text_3",
      "rdpcomposer_template_element_text_4",
      "rdpcomposer_template_element_text_5",
      "rdpcomposer_template_element_text_6",
      "rdpcomposer_template_element_text_two_column",
      "rdpcomposer_template_element_head_1",
      "rdpcomposer_template_element_image_1",
      "rdpcomposer_template_element_image_2",
      "rdpcomposer_template_element_image_and_text",
      "rdpcomposer_template_element_image_with_text",
      "rdpcomposer_template_element_list_1",
      "rdpcomposer_template_element_list_2",
      "rdpcomposer_template_element_list_3",
      "rdpcomposer_template_element_video_1",
      "rdpcomposer_template_element_audio_1",
      "rdpcomposer_template_element_iframe",
      "rdpcomposer_template_element_accordion",
      "rdpcomposer_template_element_tabs",
      "rdpcomposer_template_element_flashcards_1",
      "rdpcomposer_template_element_flashcards_2",
      "rdpcomposer_template_element_quiz_1",
      "rdpcomposer_template_element_quiz_2",
      "rdpcomposer_template_element_quiz_3",
      "rdpcomposer_template_element_quiz_5",
      "rdpcomposer_template_element_forum_1",
      "rdpcomposer_template_element_hotspots_1",
      "rdpcomposer_template_element_divider_1",
      "rdpcomposer_template_element_divider_4",
      "rdpcomposer_template_element_divider_numbered",
      "rdpcomposer_template_element_statement_1",
      "rdpcomposer_template_element_statement_2",
      "rdpcomposer_template_element_statement_3",
      "rdpcomposer_template_element_statement_4",
      "rdpcomposer_template_element_note_1",
      "rdpcomposer_template_element_quote_1",
      "rdpcomposer_template_element_quote_2",
      "rdpcomposer_template_element_quote_3",
      "rdpcomposer_template_element_quote_4",
      "rdpcomposer_template_element_quote_5",
      "rdpcomposer_template_element_quote_6",
      "rdpcomposer_template_element_timeline_1",
      "rdpcomposer_template_element_steps_1",
      "rdpcomposer_template_element_attachment_1",
      "rdpcomposer_template_element_gallery_1",
      "rdpcomposer_template_element_snippet_1",
      "rdpcomposer_template_element_3d",
      "rdpcomposer_template_element_math_formula",
      "rdpcomposer_template_element_matriz_didatica"
    ];
  }

  getTemplates() {
    var _this = this;
    var userData = UserService.getUser();
    var activeProject = UserService.getActiveProject();
    var type = userData.type;
    var accessToken = userData.access_token;
    var mimeTypes = this.getAllMimeTypes();
    var contentTypeFilter = mimeTypes.map(mime => `content_type eq 'application/${mime}'`).join(' or ');
    var filter = `filter=(${contentTypeFilter}) and (project_uid eq '${activeProject.uid}')&top=1000`;

    DamService.searchContent(filter, "", type, accessToken).then(function(data) {
      var templates = data.results;
      
      templates.forEach(template => {
        var infos = template.document.content_info;
        infos.forEach(info => {
          var values = info.split("=");
          if (!template.metadata) template.metadata = {};
          template.metadata[values[0]] = values[1];
        });
      });

      _this.setState({
        "templates": templates
      });

      // Load content for each template
      templates.forEach(template => {
        _this.loadTemplateContent(template);
      });
    });
  }

  loadTemplateContent(template) {
    var _this = this;
    var userData = UserService.getUser();
    var accessToken = userData.access_token;
    var id = template.document.content_uid;

    DamService.getContent(id, accessToken).then(function(content) {
      var parsedContent = JSON.parse(content);
      var templatesContent = _this.state.templatesContent;
      templatesContent[id] = parsedContent;
      _this.setState({
        "templatesContent": templatesContent
      });
    });
  }

  getMaxWidthClass() {
    return "width-sm"; // Default width for preview
  }

  renderTemplatePreview(template) {
    var templateData = this.state.templatesContent[template.document.content_uid];
    if (!templateData) return null;

    var scale = 0.618489583;

    try {
      var type = templateData.type;
      var element = templateData;
      var elementComponent = null;
      
      if (type === "head-1") {
        elementComponent = (
          <ElementHead1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "text-1" || type === "text-2" || type === "text-3" || type === "text-4" || type === "text-5") {
        elementComponent = (
          <ElementText
            className={`element-${element.type} element-text-x ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={true}
            content={element}
            backgroundColor={element.background_color}
            paddingTop={element.padding_top}
            paddingBottom={element.padding_bottom}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "audio-1") {
        elementComponent = (
          <ElementAudio
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "video-1") {
        elementComponent = (
          <ElementVideo
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "video-interactive-1") {
        elementComponent = (
          <ElementVideoInteractive1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "iframe") {
        elementComponent = (
          <ElementIframe
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "accordion") {
        elementComponent = (
          <ElementAccordion
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "tabs") {
        elementComponent = (
          <ElementTabs
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "flashcards-1") {
        elementComponent = (
          <ElementFlashcards1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "flashcards-2") {
        elementComponent = (
          <ElementFlashcards2
            editable={false}
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            content={element}
            contentLanguage="pt-BR"
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "text-two-column") {
        elementComponent = (
          <ElementTextTwoColumn
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            backgroundColor={element.background_color}
            paddingTop={element.padding_top}
            paddingBottom={element.padding_bottom}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "list-1" || type === "list-2" || type === "list-3") {
        elementComponent = (
          <ElementList
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "image-1" || type === "image-2") {
        elementComponent = (
          <ElementImage
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "images-gallery") {
        elementComponent = (
          <ElementImagesGallery
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "image-and-text") {
        elementComponent = (
          <ElementImageAndText
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            content={element}
            editable={false}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "image-with-text") {
        elementComponent = (
          <ElementImageWithText
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            content={element}
            editable={false}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "quiz-1") {
        elementComponent = (
          <ElementQuiz1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            contentLanguage="pt-BR"
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
            hasAiConnector={false}
          />
        );
      } else if (type === "quiz-2") {
        elementComponent = (
          <ElementQuiz2
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            contentLanguage="pt-BR"
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
            hasAiConnector={false}
          />
        );
      } else if (type === "quiz-3") {
        elementComponent = (
          <ElementQuiz3
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            contentLanguage="pt-BR"
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
            hasAiConnector={false}
          />
        );
      } else if (type === "quiz-4") {
        elementComponent = (
          <ElementQuiz4
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            contentLanguage="pt-BR"
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
            hasAiConnector={false}
          />
        );
      } else if (type === "quiz-5") {
        elementComponent = (
          <ElementQuiz5
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            contentLanguage="pt-BR"
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
            hasAiConnector={false}
          />
        );
      } else if (type === "quiz-6") {
        elementComponent = (
          <ElementQuiz6
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            contentLanguage="pt-BR"
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
            hasAiConnector={false}
          />
        );
      } else if (type === "forum-1") {
        elementComponent = (
          <ElementForum1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "divider-1") {
        elementComponent = (
          <ElementDivider1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "divider-4") {
        elementComponent = (
          <ElementDivider4
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "divider-numbered") {
        elementComponent = (
          <ElementDividerNumbered
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "virtual-index-1") {
        elementComponent = (
          <VirtualElementIndex1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "hotspots-1") {
        elementComponent = (
          <ElementHotspots1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "statement-1") {
        elementComponent = (
          <ElementStatement1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "statement-2") {
        elementComponent = (
          <ElementStatement2
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "statement-4") {
        elementComponent = (
          <ElementStatement4
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "note-1") {
        elementComponent = (
          <ElementNote1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "quote-1") {
        elementComponent = (
          <ElementQuote1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "quote-2") {
        elementComponent = (
          <ElementQuote2
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "quote-3") {
        elementComponent = (
          <ElementQuote3
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "quote-4") {
        elementComponent = (
          <ElementQuote4
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "quote-5") {
        elementComponent = (
          <ElementQuote5
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "quote-6") {
        elementComponent = (
          <ElementQuote6
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "sorted-activity-1") {
        elementComponent = (
          <ElementSortedActivity1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "timeline-1") {
        elementComponent = (
          <ElementTimeline1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "steps-1") {
        elementComponent = (
          <ElementSteps1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "attachment-1") {
        elementComponent = (
          <ElementAttachment1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "gallery-1") {
        elementComponent = (
          <ElementGallery1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "snippet-1") {
        elementComponent = (
          <ElementCodeSnippet1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "button-1") {
        elementComponent = (
          <ElementButton1
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "3d") {
        elementComponent = (
          <Element3d
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            key={`preview-${element.id || Math.random()}`}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "statement-3") {
        elementComponent = (
          <ElementStatement3
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            editable={false}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      } else if (type === "math-formula") {
        elementComponent = (
          <ElementMathFormula
            className={`element-${element.type} ${this.getMaxWidthClass()}`}
            content={element}
            headerActionsTemplate={null}
            footerActionsTemplate={null}
            onChange={() => {}}
          />
        );
      }
      // ... outros elementos

      if (elementComponent) {
        return (
          <div 
            ref={(ref) => {
              if (ref) {
                setTimeout(() => {
                  var height = ref.scrollHeight;
                  var scaledHeight = height * scale;
                  var marginAdjustment = -(height - scaledHeight);
                  ref.style.marginBottom = `${marginAdjustment}px`;
                }, 100);
              }
            }}
          >
            {elementComponent}
          </div>
        );
      }
    } catch (error) {
      console.log('Preview error for', type, ':', error);
    }

    return (
      <div style={{padding: '20px', background: '#f5f5f5', fontSize: '14px', textAlign: 'center', color: '#666'}}>
        {templateData.type ? templateData.type.toUpperCase() : 'TEMPLATE'}
      </div>
    );
  }

  applyTemplate(template) {
    var _this = this;
    var id = template.document.content_uid;
    var userData = UserService.getUser();
    var accessToken = userData.access_token;
    
    DamService.getContent(id, accessToken).then(function (templateContent) {
      var normalizedTemplate = _this.normalizeTemplateObject(JSON.parse(templateContent));
      if (_this.props.onApplyTemplate) {
        _this.props.onApplyTemplate(normalizedTemplate);
      }
      _this.renderTemplates();
    });
  }

  normalizeTemplateObject(template) {
    var obj = JSON.parse(JSON.stringify(template));
    obj = replaceCompositionObjectsIds({...obj});
    return obj;
  }

  renderTemplates() {
    this.setState({
      "render_templates": !this.state.render_templates
    });
    
    // Refresh templates when opening modal
    if (!this.state.render_templates) {
      this.getTemplates();
    }
  }

  render() {
    const {
      render_templates
    } = this.state;

    var subitems = "";
    if (this.state.subitems === "header") {
      subitems = <div>
        <div className={`rdp-composer-sidebar-subitems rdp-composer-sidebar-subitems-theme-${this.state.theme}`}>
          <SidebarSubitem
            type="head-1"
            text={this.props.labels.header.elements_descriptions.element_head_1}
            click={() => this.onClickSubitem("head-1")}
          />
          <SidebarSubitem
            type="quote-1"
            text={this.props.labels.header.elements_descriptions.element_quote_1}
            click={() => this.onClickSubitem("quote-1")}
          />
          <SidebarSubitem
            type="quote-2"
            text={this.props.labels.header.elements_descriptions.element_quote_2}
            click={() => this.onClickSubitem("quote-2")}
          />
          <SidebarSubitem
            type="quote-3"
            text={this.props.labels.header.elements_descriptions.element_quote_3}
            click={() => this.onClickSubitem("quote-3")}
          />
          <SidebarSubitem
            type="quote-4"
            text={this.props.labels.header.elements_descriptions.element_quote_4}
            click={() => this.onClickSubitem("quote-4")}
          />
          <SidebarSubitem
            type="quote-5"
            text={this.props.labels.header.elements_descriptions.element_quote_5}
            click={() => this.onClickSubitem("quote-5")}
          />
          <SidebarSubitem
            type="quote-6"
            text={this.props.labels.header.elements_descriptions.element_quote_6}
            click={() => this.onClickSubitem("quote-6")}
          />
        </div>
        <div className="rdp-composer-sidebar-overlay" onClick={() => this.closeSubitems()}></div>
      </div>;
    } else if (this.state.subitems === "text") {
      subitems = <div>
        <div className="rdp-composer-sidebar-subitems">
          <SidebarSubitem
            type="text-1"
            text={this.props.labels.header.elements_descriptions.element_text_1}
            click={() => this.onClickSubitem("text-1")}
          />
          <SidebarSubitem
            type="text-2"
            text={this.props.labels.header.elements_descriptions.element_text_2}
            click={() => this.onClickSubitem("text-2")}
          />
          <SidebarSubitem
            type="text-3"
            text={this.props.labels.header.elements_descriptions.element_text_3}
            click={() => this.onClickSubitem("text-3")}
          />
          <SidebarSubitem
            type="text-4"
            text={this.props.labels.header.elements_descriptions.element_text_4}
            click={() => this.onClickSubitem("text-4")}
          />
          <SidebarSubitem
            type="text-5"
            text={this.props.labels.header.elements_descriptions.element_text_5}
            click={() => this.onClickSubitem("text-5")}
          />
          <SidebarSubitem
            type="text-two-column"
            text={this.props.labels.header.elements_descriptions.element_text_two_column}
            click={() => this.onClickSubitem("text-two-column")}
          />
          <SidebarSubitem
            type="statement-1"
            text={this.props.labels.header.elements_descriptions.element_statement_1}
            click={() => this.onClickSubitem("statement-1")}
          />
          <SidebarSubitem
            type="statement-2"
            text={this.props.labels.header.elements_descriptions.element_statement_2}
            click={() => this.onClickSubitem("statement-2")}
          />
          <SidebarSubitem
            type="statement-3"
            text={this.props.labels.header.elements_descriptions.element_statement_3}
            click={() => this.onClickSubitem("statement-3")}
          />
          <SidebarSubitem
            type="statement-4"
            text={this.props.labels.header.elements_descriptions.element_statement_4}
            click={() => this.onClickSubitem("statement-4")}
          />
          <SidebarSubitem
            type="note-1"
            text={this.props.labels.header.elements_descriptions.element_note_1}
            click={() => this.onClickSubitem("note-1")}
          />
          <SidebarSubitem type="table-1" click={() => this.onClickSubitem("table-1")} text="Tabela personalizada com diversos recursos de edição"/>
          <SidebarSubitem
            type="math-formula"
            text={this.props.labels.header.elements_descriptions.element_math_formula}
            click={() => this.onClickSubitem("math-formula")}
          />
          <SidebarSubitem
            type="charts-infographics"
            text={this.props.labels.header.elements_descriptions.element_charts_infographics}
            click={() => this.onClickSubitem("charts-infographics")}
          />
          {/* <SidebarSubitem type="text-6" click={() => this.onClickSubitem("text-6")}/> */}
          {/* <SidebarSubitem type="text-7" click={() => this.onClickSubitem("text-7")}/> */}
        </div>
        <div className="rdp-composer-sidebar-overlay" onClick={() => this.closeSubitems()}></div>
      </div>;
    } else if (this.state.subitems === "quote") {
      subitems = <div>
        <div className="rdp-composer-sidebar-subitems">
          <SidebarSubitem type="quote-1" click={() => this.onClickSubitem("quote-1")} />
          <SidebarSubitem type="quote-2" click={() => this.onClickSubitem("quote-2")} />
          <SidebarSubitem type="quote-3" click={() => this.onClickSubitem("quote-3")} />
          <SidebarSubitem type="quote-4" click={() => this.onClickSubitem("quote-4")} />
          <SidebarSubitem type="quote-6" click={() => this.onClickSubitem("quote-6")} />
        </div>
        <div className="rdp-composer-sidebar-overlay" onClick={() => this.closeSubitems()}></div>
      </div>;
    } else if (this.state.subitems === "list") {
      subitems = <div>
        <div className="rdp-composer-sidebar-subitems">
          <SidebarSubitem
            type="list-1"
            text={this.props.labels.header.elements_descriptions.element_list_1}
            click={() => this.onClickSubitem("list-1")}
          />
          <SidebarSubitem
            type="list-2"
            text={this.props.labels.header.elements_descriptions.element_list_2}
            click={() => this.onClickSubitem("list-2")}
          />
          <SidebarSubitem
            type="list-3"
            text={this.props.labels.header.elements_descriptions.element_list_3}
            click={() => this.onClickSubitem("list-3")}
          />
        </div>
        <div className="rdp-composer-sidebar-overlay" onClick={() => this.closeSubitems()}></div>
      </div>;
    } else if (this.state.subitems === "image") {
      subitems = <div>
        <div className="rdp-composer-sidebar-subitems">
          <SidebarSubitem
            type="image-1"
            text={this.props.labels.header.elements_descriptions.element_image_1}
            click={() => this.onClickSubitem("image-1")}
          />
          <SidebarSubitem
            type="image-2"
            text={this.props.labels.header.elements_descriptions.element_image_2}
            click={() => this.onClickSubitem("image-2")}
          />
          <SidebarSubitem
            type="images-gallery"
            text={this.props.labels.header.elements_descriptions.element_images_gallery}
            click={() => this.onClickSubitem("images-gallery")}
          />
          <SidebarSubitem
            type="image-and-text"
            text={this.props.labels.header.elements_descriptions.element_image_and_text}
            click={() => this.onClickSubitem("image-and-text")}
          />
          <SidebarSubitem
            type="image-with-text"
            text={this.props.labels.header.elements_descriptions.element_image_with_text}
            click={() => this.onClickSubitem("image-with-text")}
          />
          {/* <SidebarSubitem type="image-3" click={() => this.onClickSubitem("image-3")}/> */}
          {/* <SidebarSubitem type="image-4" click={() => this.onClickSubitem("image-4")}/> */}
        </div>
        <div className="rdp-composer-sidebar-overlay" onClick={() => this.closeSubitems()}></div>
      </div>;
    } else if (this.state.subitems === "gallery") {
      subitems = <div>
        <div className="rdp-composer-sidebar-subitems">
          <SidebarSubitem type="gallery-1" click={() => this.onClickSubitem("gallery-1")} />
          {/*<SidebarSubitem type="gallery-2" click={() => this.onClickSubitem("gallery-2")} />*/}
          {/*<SidebarSubitem type="gallery-3" click={() => this.onClickSubitem("gallery-3")} />*/}
          {/*<SidebarSubitem type="gallery-4" click={() => this.onClickSubitem("gallery-4")} />*/}
        </div>
        <div className="rdp-composer-sidebar-overlay" onClick={() => this.closeSubitems()}></div>
      </div>;
    }
    else if (this.state.subitems === "multimedia") {
      subitems = <div>
        <div className="rdp-composer-sidebar-subitems">
          {/* <SidebarSubitem type="video-1" click={() => this.onClickSubitem("video-1")}/> */}
          <SidebarSubitem
            type="audio-1"
            text={this.props.labels.header.elements_descriptions.element_audio}
            click={() => this.onClickSubitem("audio-1")}
          />
          <SidebarSubitem
            type="video-1"
            text={this.props.labels.header.elements_descriptions.element_video}
            click={() => this.onClickSubitem("video-1")}
          />
          <SidebarSubitem
            type="video-interactive-1"
            text={this.props.labels.header.elements_descriptions.element_video_interactive_1}
            click={() => this.onClickSubitem("video-interactive-1")}
          />
          <SidebarSubitem
            type="iframe"
            text={this.props.labels.header.elements_descriptions.element_iframe}
            click={() => this.onClickSubitem("iframe")}
          />
          <SidebarSubitem
            type="attachment-1"
            text={this.props.labels.header.elements_descriptions.element_attachment_1}
            click={() => this.onClickSubitem("attachment-1")}
          />
          {/* <SidebarSubitem type="multimedia-4" click={() => this.onClickSubitem("multimedia-4")}/> */}
          {/* <SidebarSubitem type="multimedia-5" click={() => this.onClickSubitem("multimedia-5")}/> */}
        </div>
        <div className="rdp-composer-sidebar-overlay" onClick={() => this.closeSubitems()}></div>
      </div>;
    } else if (this.state.subitems === "interactive") {
      subitems = <div>
        <div className="rdp-composer-sidebar-subitems">
          <SidebarSubitem
            type="accordion"
            text={this.props.labels.header.elements_descriptions.element_accordion}
            click={() => this.onClickSubitem("accordion")}
          />
          <SidebarSubitem
            type="tabs"
            text={this.props.labels.header.elements_descriptions.element_tabs}
            click={() => this.onClickSubitem("tabs")}
          />
          <SidebarSubitem
            type="flashcards-1"
            text={this.props.labels.header.elements_descriptions.element_flashcards}
            click={() => this.onClickSubitem("flashcards-1")}
          />
          <SidebarSubitem
            type="flashcards-2"
            text={this.props.labels.header.elements_descriptions.element_flashcards_2}
            click={() => this.onClickSubitem("flashcards-2")}
          />
          <SidebarSubitem
            type="hotspots-1"
            text={this.props.labels.header.elements_descriptions.element_hotspots_1}
            click={() => this.onClickSubitem("hotspots-1")}
          />
          <SidebarSubitem
            type="sorted-activity-1"
            text={this.props.labels.header.elements_descriptions.sorted_activity_1}
            click={() => this.onClickSubitem("sorted-activity-1")}
          />
          <SidebarSubitem
            type="timeline-1"
            text={this.props.labels.header.elements_descriptions.element_timeline_1}
            click={() => this.onClickSubitem("timeline-1")}
          />
          <SidebarSubitem
            type="steps-1"
            text={this.props.labels.header.elements_descriptions.element_steps_1}
            click={() => this.onClickSubitem("steps-1")}
          />
          <SidebarSubitem
            type="snippet-1"
            text={this.props.labels.header.elements_descriptions.element_snippet_1}
            click={() => this.onClickSubitem("snippet-1")}
          />
          <SidebarSubitem
            type="button-1"
            text={this.props.labels.header.elements_descriptions.element_button_1}
            click={() => this.onClickSubitem("button-1")}
          />
          <SidebarSubitem
            type="button-2"
            text={this.props.labels.header.elements_descriptions.element_button_2}
            click={() => this.onClickSubitem("button-2")}
          />
          <SidebarSubitem
            type="interactive-video"
            text={this.props.labels.header.elements_descriptions.element_interactive_video}
            click={() => this.onClickSubitem("interactive-video")}
          />
          <SidebarSubitem
            type="three-d"
            text={this.props.labels.header.elements_descriptions.element_3d}
            click={() => this.onClickSubitem("3d")}
          />
          
          {/* <SidebarSubitem type="interactive-3" click={() => this.onClickSubitem("interactive-3")}/>
          <SidebarSubitem type="interactive-4" click={() => this.onClickSubitem("interactive-4")}/>
          <SidebarSubitem type="interactive-5" click={() => this.onClickSubitem("interactive-5")}/>
          <SidebarSubitem type="interactive-6" click={() => this.onClickSubitem("interactive-6")}/>
          <SidebarSubitem type="interactive-7" click={() => this.onClickSubitem("interactive-7")}/>
          <SidebarSubitem type="interactive-9" click={() => this.onClickSubitem("interactive-9")}/>
          <SidebarSubitem type="interactive-10" click={() => this.onClickSubitem("interactive-10")}/>
          <SidebarSubitem type="interactive-11" click={() => this.onClickSubitem("interactive-11")}/> */}
        </div>
        <div className="rdp-composer-sidebar-overlay" onClick={() => this.closeSubitems()}></div>
      </div>;
    } else if (this.state.subitems === "quiz") {
      subitems = <div>
        <div className="rdp-composer-sidebar-subitems">
          <SidebarSubitem text={this.props.labels.header.elements_descriptions.element_quiz_1} type="quiz-1" click={() => this.onClickSubitem("quiz-1")} />
          <SidebarSubitem text={this.props.labels.header.elements_descriptions.element_quiz_2} type="quiz-2" click={() => this.onClickSubitem("quiz-2")} />
          <SidebarSubitem text={this.props.labels.header.elements_descriptions.element_quiz_3} type="quiz-3" click={() => this.onClickSubitem("quiz-3")} />
          <SidebarSubitem text={this.props.labels.header.elements_descriptions.element_quiz_4} type="quiz-4" click={() => this.onClickSubitem("quiz-4")} />
          <SidebarSubitem text={this.props.labels.header.elements_descriptions.element_quiz_5} type="quiz-5" click={() => this.onClickSubitem("quiz-5")} />
          <SidebarSubitem text={this.props.labels.header.elements_descriptions.element_quiz_6} type="quiz-6" click={() => this.onClickSubitem("quiz-6")} />
        </div>
        <div className="rdp-composer-sidebar-overlay" onClick={() => this.closeSubitems()}></div>
      </div>;
    } else if (this.state.subitems === "chart") {
      subitems = <div>
        <div className="rdp-composer-sidebar-subitems">
          <SidebarSubitem type="chart-1" click={() => this.onClickSubitem("chart-1")} />
          <SidebarSubitem type="chart-2" click={() => this.onClickSubitem("chart-2")} />
          <SidebarSubitem type="chart-3" click={() => this.onClickSubitem("chart-3")} />
        </div>
        <div className="rdp-composer-sidebar-overlay" onClick={() => this.closeSubitems()}></div>
      </div>;
    } else if (this.state.subitems === "divider") {
      subitems = <div>
        <div className="rdp-composer-sidebar-subitems">
          <SidebarSubitem type="divider-1" click={() => this.onClickSubitem("divider-1")} />
          <SidebarSubitem type="divider-2" click={() => this.onClickSubitem("divider-2")} />
          <SidebarSubitem type="divider-3" click={() => this.onClickSubitem("divider-3")} />
          <SidebarSubitem type="divider-4" click={() => this.onClickSubitem("divider-4")} />
        </div>
        <div className="rdp-composer-sidebar-overlay" onClick={() => this.closeSubitems()}></div>
      </div>;
    } else if (this.state.subitems === "activities") {
      subitems = <div>
        <div className="rdp-composer-sidebar-subitems">
          <SidebarSubitem text={this.props.labels.header.elements_descriptions.element_forum_1} type="forum-1" click={() => this.onClickSubitem("forum-1")} />
          {/* <SidebarSubitem text={this.props.labels.header.elements_descriptions.element_tex_1} type="tex-1" click={() => this.onClickSubitem("tex-1")} /> */}
        </div>
        <div className="rdp-composer-sidebar-overlay" onClick={() => this.closeSubitems()}></div>
      </div>
    } else if (this.state.subitems === "planning") {
      subitems = <div>
        <div className="rdp-composer-sidebar-subitems">
          <SidebarSubitem text={this.props.labels.header.elements_descriptions.element_matriz_didatica} type="matriz-didatica" click={() => this.onClickSubitem("matriz-didatica")} />
        </div>
        <div className="rdp-composer-sidebar-overlay" onClick={() => this.closeSubitems()}></div>
      </div>
    } else if (this.state.subitems === "markers") {
      subitems = <div>
        <div className="rdp-composer-sidebar-subitems">
          <SidebarSubitem text={this.props.labels.header.elements_descriptions.virtual_element_index_1} type="virtual-index-1" click={() => this.onClickSubitem("virtual-index-1")} />
          <SidebarSubitem text={this.props.labels.header.elements_descriptions.element_divider_1} type="divider-1" click={() => this.onClickSubitem("divider-1")} />
          <SidebarSubitem text={this.props.labels.header.elements_descriptions.element_divider_4} type="divider-4" click={() => this.onClickSubitem("divider-4")} />
          <SidebarSubitem text={this.props.labels.header.elements_descriptions.element_divider_numbered} type="divider-numbered" click={() => this.onClickSubitem("divider-numbered")} />
        </div>
        <div className="rdp-composer-sidebar-overlay" onClick={() => this.closeSubitems()}></div>
      </div>
    } else {
      subitems = "";
    }

    return (
      <div className={`rdp-composer-sidebar rdp-composer-sidebar-theme-${this.state.theme}`} style={
        {
          "right": this.props.openedAi === true ? "350px" : "0px"
        }
      }>
        {this.props.isEmbed &&
          <span className={`rdp-composer-sidebar-back-embed`} onClick={() => this.props.onBackClick()}>{this.props.labels.header.back_btn}</span>
        }
        {!this.props.isEmbed &&
          <span className="rdp-composer-sidebar-back" onClick={() => this.props.onBackClick()}>{this.props.labels.header.back_btn}</span>
        }
        {/* <span className="rdp-composer-sidebar-logo"></span> */}
        <ul className={`rdp-composer-sidebar-items ${!this.props.canEditComposition ? "disabled" : ""}`}>
          <SidebarBtn label={this.props.labels.header.element_header} icon="header" click={() => this.renderSubitems("header")} />
          <SidebarBtn label={this.props.labels.header.element_text} icon="text" click={() => this.renderSubitems("text")} />
          <SidebarBtn label={this.props.labels.header.element_list} icon="list" click={() => this.renderSubitems("list")} />
          {/* <SidebarBtn label="Declaração" icon="statement" click={() => this.renderSubitems("statement")}/> */}
          {/* <SidebarBtn label="Depoimento" icon="quote" click={() => this.renderSubitems("quote")}/> */}
          {/* <SidebarBtn label="Lista" icon="list" click={() => this.renderSubitems("list")}/> */}
          <SidebarBtn label={this.props.labels.header.element_image} icon="image" click={() => this.renderSubitems("image")} />
          <SidebarBtn label="Galeria" icon="gallery" click={() => this.renderSubitems("gallery")}/>
          <SidebarBtn label={this.props.labels.header.element_multimedia} icon="multimedia" click={() => this.renderSubitems("multimedia")} />
          <SidebarBtn label={this.props.labels.header.element_interactivity} icon="interactive" click={() => this.renderSubitems("interactive")} />
          <SidebarBtn label={this.props.labels.header.element_quiz} icon="quiz" click={() => this.renderSubitems("quiz")} />
          <SidebarBtn label={this.props.labels.header.element_activities} icon="activities" click={() => this.renderSubitems("activities")} />
          <SidebarBtn label={this.props.labels.header.element_markers} icon="markers" click={() => this.renderSubitems("markers")} />
          <SidebarBtn label={this.props.labels.header.element_planning} icon="checklist-planner" click={() => this.renderSubitems("planning")} />

          <SidebarBtn label={this.props.labels.header.element_templates} icon="template" click={() => this.renderTemplates()} />
          {/* <SidebarBtn label="Gráfico" icon="chart" click={() => this.renderSubitems("chart")}/> */}
          {/* <SidebarBtn label="Divisor" icon="divider" click={() => this.renderSubitems("divider")}/> */}
        </ul>
        {/* <span className="rdp-composer-sidebar-preview" onClick={() => this.openPreview()}>Preview</span> */}
        {subitems}
        {/* OPEN AI INTELIGÊNCIA ARTIFICIAL IA AI
          <span className="rdp-composer-sidebar-help-btn" onClick={() => this.props.onToggleHelp()}></span>
        */}
        <span className="rdp-composer-sidebar-menu-btn" onClick={() => this.props.onToggleMenu()}></span>

        {this.renderMenu()}

        {render_templates &&
          <div className="rdp-composer-sidebar-templates">
            <div className="rdp-composer-sidebar-templates-overlay" onClick={() => this.renderTemplates()}></div>
            <div className="rdp-composer-sidebar-templates-body">
              <div className="rdp-composer-sidebar-templates-header">
                <span className="rdp-composer-sidebar-templates-header-title">Templates</span>
                <span className="rdp-composer-sidebar-templates-header-close" onClick={() => this.renderTemplates()}>Fechar</span>
              </div>
              <div className="rdp-composer-sidebar-templates-search">
                <input
                  type="text"
                  placeholder="Buscar templates..."
                  value={this.state.searchTerm}
                  onChange={(e) => this.handleSearchChange(e)}
                  className="rdp-composer-sidebar-templates-search-input"
                />
              </div>
              <div className="rdp-composer-sidebar-templates-items">
                {(() => {
                  var filteredTemplates = this.getFilteredTemplates();
                  
                  if (filteredTemplates) {
                    // Show flat list when searching
                    return filteredTemplates.map((template, index) => (
                      <div key={index} className="rdp-composer-sidebar-templates-item" onClick={() => this.applyTemplate(template)}>
                        <div className="rdp-composer-sidebar-templates-item-info">
                          <span className="rdp-composer-sidebar-templates-item-name">
                            {template.metadata ? template.metadata.file_name : 'Template sem nome'}
                          </span>
                        </div>
                        <div className="rdp-composer-sidebar-templates-item-preview">
                          {this.renderTemplatePreview(template)}
                        </div>
                      </div>
                    ));
                  } else {
                    // Show categories when not searching
                    var categories = this.categorizeTemplates();
                    return Object.keys(categories).map(categoryName => {
                      var templates = categories[categoryName];
                      if (templates.length === 0) return null;
                      
                      var isExpanded = this.state.expandedCategories[categoryName];
                      
                      return (
                        <div key={categoryName}>
                          <div 
                            className={`rdp-composer-sidebar-templates-item-collapse ${isExpanded ? 'icon-up' : 'icon-down'}`}
                            onClick={() => this.toggleCategory(categoryName)}
                          >
                            {categoryName} ({templates.length})
                          </div>
                          {isExpanded && templates.map((template, index) => (
                            <div key={index} className="rdp-composer-sidebar-templates-item" onClick={() => this.applyTemplate(template)}>
                              <div className="rdp-composer-sidebar-templates-item-info">
                                <span className="rdp-composer-sidebar-templates-item-name">
                                  {template.metadata ? template.metadata.file_name : 'Template sem nome'}
                                </span>
                              </div>
                              <div className="rdp-composer-sidebar-templates-item-preview">
                                {this.renderTemplatePreview(template)}
                              </div>
                            </div>
                          ))}
                        </div>
                      );
                    });
                  }
                })()}
                {this.state.templates.length === 0 && (
                  <div className="rdp-composer-sidebar-templates-empty">
                    Nenhum template encontrado
                  </div>
                )}
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}
